import { gql } from '@apollo/client';
import { InstitutionFragment } from './institution.fragment';
export const GetInstitutionInfo = gql `
    query GetInstitutionInfo($institutionId: InstitutionId!) {
        institutions(institutionId: $institutionId) {
            ...InstitutionFragment
        }
    }
    ${InstitutionFragment}
`;
